<template>
    <div class="card">
      <!-- <div style="text-align:center">
      <h3><b>MIS</b></h3>
      </div>-->
      <div v-if="selectedTab == 'SBM Dashboard'" style="margin-top:20px;height:100%">
        <superset_dashboard
          :client_id="client_id_local"
          user_id="64ef3bf9e2b8402f722b94c9"
          :superset_id="superset_id"
          v-if="superset_id"
        ></superset_dashboard>
      </div>
    </div>
</template>
<script>
import apis from "@/apis";
import axios from "axios";
import { Buffer } from "buffer";
import GoogleMapComponent from "../components/GoogleMap";
import superset_dashboard from "../components/superset_dashboard";
import GoogleMapDashboard from "../components/GoogleMapDashboard";
import gps from "../components/gps";
import { Tabs, Tab, TabPanels, TabPanel } from "vue3-tabs";
import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import {
  GoogleMap,
  Marker,
  MarkerCluster,
  InfoWindow,
  Polyline
} from "vue3-google-map";
import VueGauge from "../components/VueGauge";
import solid_waste from "../components/solid_waste";
import plastic from "../components/plastic";
import fical from "../components/fical";
export default {
  data() {
    return {
      ride_productDialog: false,
      original_speed_marker: [],
      speed: true,
      total_distance: "",
      total_time: "",
      car_marker: {},
      reg_number: "",
      vehicle_dropdownItems: [],
      vehicle_dropdownItem: "",
      refreshKey: 0,

      route_name: "",
      tbl_name: "",
      original_marker_data: [],
      visit: true,
      pending: true,
      polyline_show: true,
      home_productDialog: false,
      live_polypath: [],
      home_list: [],
      original_home_list: [],
      list_loader: false,
      driver_name: "",
      driver_photo: "",
      driver_mobile_number: "",
      vehicle_registration_number: "",
      vehicle_model: "",
      vehicle_image: "",
      vehicle_type: "",
      fuel_type: "",
      make_year: "",
      fitness_validity: "",
      puc_validity: "",
      insurance_validity: "",
      documents: "",
      owner_name: "",
      owner_photo: "",
      owner_mobile_number: "",
      total_stops: 0,
      visited: 0,
      dl_number: "",
      dl_expiry_date: "",
      accidental_history: "",
      available24by7: "",
      shift_time_from: "",
      shift_time_to: "",
      ride_details: "",
      client_group_ids: "",
      vehicle_from_date: "",
      vehicle_to_date: "",
      set_loading: false,
      map_productDialog: false,
      selectedProduct: null,
      vehicle_data: [],
      search_vehicle_data: [],
      client_id_local: [],
      user_id: "",
      superset_id: "",
      isZoomed: false,
      isZoomed1: false,
      chartData1: null,
      fullPage: true,
      user_key: "",
      client_id_dropdown: [],
      client_id_search: "",
      district_id_search: "",
      taluka_id_search: "",
      village_id_search: "",
      block_id_search: "",
      routeitem_multiselect: "",
      routeitem: "",
      routeitems: [],
      isLoadingModel: false,
      pieOptions: null,
      tabs: [
        "SBM Dashboard",
        "Individual/Place Visits",
        "Dumping Ground",
        "Top/Bottom Performers",
        "30 Days Analysis"
      ],
      selectedTab: "SBM Dashboard",

      ride_tabs: [
        "Driver Details",
        "Vehicle Details",
        "Owner Details",
        "Ride Details"
      ],
      selected_ride_Tab: "Driver Details",

      pieData: {},
      pieData1: {},
      center: { lat: 19.0626704, lng: 73.005094 },
      center1: {},

      vehicle_map_start: {},
      vehicle_map_end: {},
      map_polypath: {},

      centerstart: {},
      polyline: [],
      polyline1: [],
      polypath: {},
      search_key: "",
      home: true,
      random: 0,
      token: "",
      get_date: "",
      get_date_2: "",
      locations1: [],
      locations: [
        { lat: 19.0626704, lng: 73.005094, name: "Prathamesh" },
        { lat: 28.38, lng: 77.12, name: "Sanjay" }
      ],
      markers: [],
      speed_marker: [],
      messages: [],
      inputMessageText: "",
      form: {
        roomName: "63a939f2b319a2f01eb75798",
        userName: "639c6caae0aa678e9f6de543"
      },
      products: null,
      todayslectures: [],

      travellist: [],
      travellist_filter: [],
      lastNumber: 1,
      barOptions: null,
      barOptions1: null,
      items: [
        { label: "Add New", icon: "pi pi-fw pi-plus" },
        { label: "Remove", icon: "pi pi-fw pi-minus" }
      ],
      lineOptions: null
    };
  },
  productService: null,
  themeChangeListener: null,
  async mounted() {},
  beforeUnmount() {
    EventBus.off("change-theme", this.themeChangeListener);
  },
  async created() {
    window.Buffer = window.Buffer || Buffer;
    this.superset_id = "10ab0a3c-8466-4e86-adc6-770396cdff9e";
    this.selectedTab = "SBM Dashboard";
  },
  watch: {
    selectedTab() {
      if (this.selectedTab == "SBM Dashboard") {
        this.superset_id = "10ab0a3c-8466-4e86-adc6-770396cdff9e";
      }
      if (this.selectedTab == "SBM State Dashboard") {
        this.superset_id = "8e307108-1a22-4cdf-9c31-cbf4abfcf56b";
      }

      if (this.selectedTab == "Individual/Place Visits") {
        this.superset_id = "3d7f5fbe-e352-47fd-b6a4-3ac04cf897a7";
      }
      if (this.selectedTab == "Vehicles Visits") {
        this.vehicle_data = [];
        this.search_vehicle_data = [];
      }
      if (this.selectedTab == "Vehicles Summary") {
        this.superset_id = "687f9c1b-f5d6-444c-b353-3413cfcc140d";
      }
      if (this.selectedTab == "Dumping Ground") {
        this.superset_id = "77cb787e-1a98-471a-a6be-ba69296ae97f";
      }
      if (this.selectedTab == "Top/Bottom Performers") {
        this.superset_id = "fbe0589f-20e9-4c66-b251-3dc4dc9963f7";
      }
      if (this.selectedTab == "30 Days Analysis") {
        this.superset_id = "1a0a1012-9e3d-4305-87b5-5ba657b9ba12";
      }
    }
  },
  methods: {},
  components: {
    Tabs,
    Tab,
    TabPanels,
    gps,
    superset_dashboard,
    GoogleMapDashboard,
    TabPanel,
    GoogleMap,
    Marker,
    MarkerCluster,
    InfoWindow,
    Polyline,
    GoogleMapComponent,
    "l-map": LMap,
    LTileLayer,
    LMarker,
    VueGauge,
    solid_waste,
    plastic,
    fical
  }
};
</script>
<style>
</style>
<style scoped>
#mapContainer {
  width: 100%;
  height: 100vh;
}

.p-button-sm {
  font-size: 0.7rem;
  padding: 0.4rem 0.8rem;
}

.bell {
  display: block;
  color: #9e9e9e;
  -webkit-animation: ring 4s 0.7s ease-in-out infinite;
  -webkit-transform-origin: 50% 4px;
  -moz-animation: ring 4s 0.7s ease-in-out infinite;
  -moz-transform-origin: 50% 4px;
  animation: ring 4s 0.2s ease-in-out infinite;
  transform-origin: 50% 4px;
}

.card {
  cursor: pointer;
}
</style>